import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, unref as _unref, createVNode as _createVNode, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, isRef as _isRef } from "vue"

const _hoisted_1 = { class: "users" }
const _hoisted_2 = { class: "app-wrapper" }
const _hoisted_3 = { class: "section-header" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_5 = { class: "first-column-with-icon-type" }
const _hoisted_6 = { class: "name-type-block" }
const _hoisted_7 = { class: "name-data" }
const _hoisted_8 = { class: "type-data-mini" }
const _hoisted_9 = { class: "first-column-with-icon-type" }
const _hoisted_10 = { class: "name-type-block" }
const _hoisted_11 = { class: "name-data" }
const _hoisted_12 = {
  key: 0,
  class: "type-data-mini"
}
const _hoisted_13 = { class: "first-column-with-icon-type" }
const _hoisted_14 = { class: "name-type-block" }
const _hoisted_15 = { class: "type-data-block" }
const _hoisted_16 = { class: "type-data-block" }
const _hoisted_17 = { class: "emq-table-footer" }

import { getEvseProfileList } from '@/api/evses'
// import { SEARCH_FORM_RES_PROPS as colProps } from '@/common/constants'
import CommonPagination from '@/components/commonPagination.vue'
import useI18nTl from '@/hooks/useI18nTl'
import usePaginationRemember from '@/hooks/usePaginationRemember'
import usePaginationWithHasNext from '@/hooks/usePaginationWithHasNext'
import { Refresh, Plus } from '@element-plus/icons-vue'
// import { ArrowDown, ArrowUp, Refresh, RefreshLeft, Search, Plus } from '@element-plus/icons-vue'
import { pick } from 'lodash'
// import useProtocolEnums from '@/hooks/useProtocolEnums'
// import { ElMessage, ElMessageBox } from 'element-plus'
import { checkMenuShow } from '@/store/tool'
// import { dateFormat, stringifyObjSafely } from '@/common/tools'
import { dateFormat, throttleBtn } from '@/common/tools'
import EvseProflieUpsert from './EvseProflieUpsert.vue'
import EvseProflieSchedule from './EvseProflieSchedule.vue'
import EvseProflieLately from './EvseProflieLately.vue'


import { defineComponent, ref, defineProps } from 'vue'
const __default__ = defineComponent({
  name: 'EvseProflie',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  evseid: {
    type: String,
    default: '0',
  },
  connectorNum: {
    type: Number,
    default: 1,
  },
},
  setup(__props) {

const props = __props

const { t } = useI18nTl('Evses')

const showLatestChargingScheduleDialog = ref(false)
const showChargingProfileDataIsView = ref(false)
const showChargingProfileData = ref({})
const showDialog = ref(false)
// const showMoreQuery = ref(false)
const tableData = ref([])
const lockTable = ref(false)
const TableCom = ref()
const params = ref({})
// const fuzzyParams = ref<Record<string, any>>({})
// const { enableSelects, evseStateSelects } = useProtocolEnums()
const { pageMeta, pageParams, initPageMeta, setPageMeta, toPageMeta } = usePaginationWithHasNext()
const { updateParams } = usePaginationRemember('evses-detail')



const getLatestChargingSchedule = () => {
  showLatestChargingScheduleDialog.value = true
}

// const profileView = (row: any) => {
//   showDialog.value = true
//   showChargingProfileDataIsView.value = true
//   showChargingProfileData.value = row
// }
const addData = () => {
  console.log('====== EvseProfile cilck add ======', showDialog.value)
  showDialog.value = true
  showChargingProfileDataIsView.value = false
  showChargingProfileData.value = {}
}

// const handleSearch = async () => {
//   params.value = genQueryParams(fuzzyParams.value)
//   loadTables()
// }

// const handleReset = () => {
//   fuzzyParams.value = {}
//   handleSearch()
// }

// const genQueryParams = (params: Record<string, any>) => {
//   let newParams: Record<string, any> = {}
//   const { id, name, enable, operatorID, sn } = params
//   newParams = {
//     id: id || undefined,
//     name: name || undefined,
//     enable: enable || undefined,
//     operatorID: operatorID || undefined,
//     sn: sn || undefined,
//   }
//   return newParams
// }

const loadTables = async () => {
  lockTable.value = true
  const sendParams: any = {
    ...params.value,
    pageReq: {
      ...pageParams.value,
    },
  }
  sendParams.evseId = props.evseid

  try {
    const { list = [], pageReply = {} } = await getEvseProfileList(sendParams)
    const meta = toPageMeta(sendParams.pageReq, pageReply)
    tableData.value = list
    setPageMeta(meta)
    updateParams({ ...pick(meta, ['limit', 'page']), ...params.value })
  } catch (error) {
    tableData.value = []
    initPageMeta()
  } finally {
    lockTable.value = false
  }
}
const loadDatasRefreshLimit = throttleBtn(loadTables)
loadTables()

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_role = _resolveDirective("role")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _withDirectives((_openBlock(), _createBlock(_component_el_button, {
          type: "primary",
          plain: "",
          onClick: getLatestChargingSchedule
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('Base.lately')), 1)
          ]),
          _: 1
        })), [
          [_directive_role, 'evseProfileLately']
        ]),
        _withDirectives((_openBlock(), _createBlock(_component_el_button, {
          type: "primary",
          icon: _unref(Plus),
          onClick: addData
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('Base.create')), 1)
          ]),
          _: 1
        }, 8, ["icon"])), [
          [_directive_role, 'evseProfileUpsert']
        ]),
        _createVNode(_component_el_button, {
          type: "primary",
          plain: "",
          icon: _unref(Refresh),
          onClick: _unref(loadDatasRefreshLimit)
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('Base.refresh')), 1)
          ]),
          _: 1
        }, 8, ["icon", "onClick"])
      ]),
      _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        data: tableData.value,
        ref_key: "TableCom",
        ref: TableCom,
        "row-key": "id"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            prop: "profile.chargingProfileId",
            "min-width": "40",
            label: "ID",
            show: "false",
            align: "center"
          }),
          _createVNode(_component_el_table_column, {
            prop: "operatorName",
            "min-width": "100",
            label: _unref(t)('Evses.chargingProfilePurpose'),
            show: "false"
          }, {
            default: _withCtx(({ row }) => [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("span", _hoisted_7, _toDisplayString(row.profile.chargingProfilePurpose), 1),
                  _createElementVNode("span", _hoisted_8, _toDisplayString(row.profile.transactionId != '' && row.profile.transactionId != '0'
                    ? row.profile.transactionId
                    : '-'), 1)
                ])
              ])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "operatorName",
            "min-width": "80",
            label: _unref(t)('Evses.chargingProfileKind'),
            show: "false"
          }, {
            default: _withCtx(({ row }) => [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("span", _hoisted_11, _toDisplayString(row.profile.chargingProfileKind), 1),
                  (row.profile.chargingProfileKind == 'Recurring')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(row.profile.recurrencyKind), 1))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "profile.stackLevel",
            "min-width": "80",
            label: _unref(t)('Evses.stackLevel'),
            show: "false",
            "show-overflow-tooltip": ""
          }, null, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "chargingbeginTime",
            "min-width": "100",
            label: _ctx.$t('Order.chargingRangeTime')
          }, {
            default: _withCtx(({ row }) => [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("span", _hoisted_15, _toDisplayString(row.profile.validFrom != '' ? row.profile.validFrom : '-'), 1),
                  _createElementVNode("span", _hoisted_16, _toDisplayString(row.profile.validTo ? row.profile.validTo : '-'), 1)
                ])
              ])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "chargingbeginTime",
            "min-width": "250",
            label: _ctx.$t('Evses.chargingSchedule')
          }, {
            default: _withCtx(({ row }) => [
              _createVNode(EvseProflieSchedule, {
                isView: true,
                schedule: row.profile.chargingSchedule
              }, null, 8, ["schedule"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "createdAt",
            "min-width": "80",
            label: _ctx.$t('Base.createdAt')
          }, {
            default: _withCtx(({ row }) => [
              _createElementVNode("span", null, _toDisplayString(_unref(dateFormat)(Number(row.createdAt) * 1000)), 1)
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _: 1
      }, 8, ["data"])), [
        [
          _directive_loading,
          lockTable.value,
          void 0,
          { lock: true }
        ]
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createVNode(CommonPagination, {
          metaData: _unref(pageMeta),
          "onUpdate:metaData": _cache[0] || (_cache[0] = ($event: any) => (_isRef(pageMeta) ? (pageMeta).value = $event : null)),
          onLoadPage: loadTables
        }, null, 8, ["metaData"])
      ]),
      _createElementVNode("div", null, [
        _createVNode(EvseProflieUpsert, {
          modelValue: showDialog.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((showDialog).value = $event)),
          isView: showChargingProfileDataIsView.value,
          profile: showChargingProfileData.value,
          evseId: props.evseid,
          onSubmitted: loadTables
        }, null, 8, ["modelValue", "isView", "profile", "evseId"])
      ])
    ]),
    _createVNode(EvseProflieLately, {
      modelValue: showLatestChargingScheduleDialog.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((showLatestChargingScheduleDialog).value = $event)),
      evseId: props.evseid,
      connectorNum: props.connectorNum
    }, null, 8, ["modelValue", "evseId", "connectorNum"])
  ]))
}
}

})